import { GET_LIST } from 'react-admin';
import queryString from 'query-string';
import logger from '../utils/logger';
import { PROVIDER_AVAILABILITY_RESOURCE_NAME } from './availability-schedules.model';

// V2-only resource (no V1 equivalent), always use V2 API URL
const getApiUrl = () => import.meta.env.VITE_API_V2_URL;

const providerRequestToHttpRequest = (requestType: string, requestParams: any) => {
  switch (requestType) {
    case GET_LIST: {
      const filters = requestParams.filter || {};

      const query: Record<string, string> = {};

      if (filters.search) {
        query.search = filters.search;
      }
      if (filters.contact_type) {
        query.contact_type = filters.contact_type;
      }

      const url = `${getApiUrl()}/healthie/providers/availability/?${queryString.stringify(query)}`;

      logger.log('[ProviderAvailability DataProvider] GET_LIST request:', {
        filters,
        url,
      });

      return { url };
    }

    default:
      throw new Error(`Unsupported fetch action type ${requestType}`);
  }
};

const httpResponseToProviderData = (httpResponse: any, requestType: string, _requestParams: any) => {
  const { json } = httpResponse;

  switch (requestType) {
    case GET_LIST: {
      if (json.success && json.data) {
        logger.log('[ProviderAvailability DataProvider] GET_LIST response:', {
          count: json.data.length,
          total: json.pagination?.total,
        });

        return {
          data: json.data,
          total: json.pagination?.total || json.data.length,
        };
      }

      logger.warn('[ProviderAvailability DataProvider] Unexpected response format:', json);
      return {
        data: Array.isArray(json) ? json : [],
        total: Array.isArray(json) ? json.length : 0,
      };
    }

    default:
      return { data: json };
  }
};

export default {
  resource: PROVIDER_AVAILABILITY_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData,
  },
};
